module.exports = __webpack_public_path__ + "static/media/quantrol.1f38349e.pdf";